import leadscoring from "./leadscoring";
import metals from "./metals";
import agriculture from "./agriculture";
import mining from "./mining";
import realty from "./realty";
import aiservices from "./aiservices";
import precast from "./precast";

/** All subdomain slugs — SmartCampus excluded (hosted separately). */
export const SUBDOMAIN_SLUGS = [
  "leadscoring",
  "metals",
  "agriculture",
  "mining",
  "realty",
  "aiservices",
  "precast",
];

export const subdomainConfigs = {
  leadscoring,
  metals,
  agriculture,
  mining,
  realty,
  aiservices,
  precast,
};

export function getSubdomainConfig(slug) {
  return subdomainConfigs[slug] ?? null;
}

export function getOtherSubdomains(currentSlug) {
  return SUBDOMAIN_SLUGS.filter((s) => s !== currentSlug).map((slug) => ({
    slug,
    name: subdomainConfigs[slug].shortName,
    host: subdomainConfigs[slug].host,
  }));
}

export { subdomainImage } from "./utils";
